import { useEffect, useState } from "react";
import { Timer } from "lucide-react";
import { maintenanceModeApi } from "@/lib/maintenanceMode.api";

const POLL_INTERVAL_MS = 60_000;

// App-wide banner while a maintenance-mode session is active (C3) — real
// users may still be working concurrently, so this is a visibility aid, not
// a lockout. Polls a lightweight status endpoint any authenticated user can
// read.
export function MaintenanceModeBanner() {
  const [expiresAt, setExpiresAt] = useState<string | null>(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    let cancelled = false;

    async function check() {
      try {
        const response = await maintenanceModeApi.status();
        if (cancelled) return;
        setVisible(response.data.enabled);
        setExpiresAt(response.data.expiresAt);
      } catch {
        // Non-critical UI aid — silently skip a failed poll.
      }
    }

    check();
    const interval = setInterval(check, POLL_INTERVAL_MS);
    return () => {
      cancelled = true;
      clearInterval(interval);
    };
  }, []);

  if (!visible) return null;

  return (
    <div className="flex items-center justify-center gap-2 bg-warning-bg px-3 py-1.5 text-[11.5px] font-medium text-warning-text">
      <Timer size={13} />
      Mode maintenance actif
      {expiresAt ? ` — expire le ${new Date(expiresAt).toLocaleString("fr-FR")}` : ""}
    </div>
  );
}
